module.exports = __webpack_public_path__ + "source/img/image.0ec8d4fa.png";